import { RequestConfig } from '@/interface'

const PRIFIX = 'ypgl/fprz/'
const intoAccountConfig: RequestConfig = {
  // 企业统计
  fprzQytj: {
    url: `${PRIFIX}qytj`,
    method: 'post'
  },
  // 企业数据概览
  qysjgl: {
    url: `${PRIFIX}fprzQysjgl`,
    method: 'post'
  },
  // 海关缴款书列表
  fprzHgjkslb: {
    url: `${PRIFIX}fprzHgjkslb`,
    method: 'post'
  },
  // 代扣代缴完税凭证
  fprzDkdjwspzlb: {
    url: `${PRIFIX}fprzDkdjwspzlb`,
    method: 'post'
  },
  // 发票入账
  fprz: {
    url: `${PRIFIX}rz`,
    method: 'post'
  },
  // 发票入账结果
  fprzJg: {
    url: `${PRIFIX}rzjg`,
    method: 'get'
  },
  // 勾选记录列表
  qygxjl: {
    url: `${PRIFIX}qygxjl`,
    method: 'post'
  },
  // 勾选记录详情
  qygxjlxq: {
    url: `${PRIFIX}qygxjlxq`,
    method: 'post'
  },
  // 勾选记录详情导出
  gxjrExport: {
    url: `${PRIFIX}export`,
    method: 'post'
  },
  // 海关缴款书下载
  hgjkslbDownload: {
    url: `${PRIFIX}hgjkslbDownload`,
    method: 'post'
  },
  // 代扣代缴完税凭证下载
  dkdjwspzDownload: {
    url: `${PRIFIX}dkdjwspzDownload`,
    method: 'post'
  }
}
export default intoAccountConfig
